<video controls [style.height]="'150px'" [style.width]="'75%'">
    <source [src]="value+cid">
</video>